import React, {Component} from "react";
import {overlayAssetConfig} from "../../../../data/overlay"

import {Icomponent} from "../interface/Icomponent";
import {Ibutton, objectTypes} from "../../buttonpanel/interface/Ibuttons";


interface IframeworkOverlay {
    data: {
        COMPONENTS: any,

    }

}

export const frameworkOverlay: IframeworkOverlay = {

    data: {
        "COMPONENTS": [],
    }

};

export const OverlayConfigurationContext = React.createContext(
    {}
);